module.exports = __webpack_public_path__ + "static/media/location-pin-white.f58124e0.svg";